export default 
{
  "and": [
    {
      "==": [
        {
          "var": "slider"
        },
        35
      ]
    },
  ]
};